'use strict';
const angular = require('angular');

export class reservationAddComponent {
  constructor(Auth, $scope) {
    'ngInject';

    this.Auth = Auth;
    this.$scope = $scope;

    this.startOpened = false;
    this.endOpened = false;
    this.isInvalid = true;
    this.reason = "";
    this.now = new Date();

    this.lblOkButton = "Make A Reservation";
    this.lblHeader = "Make A Reservation";

    this.stateEnum = [{
      value: 'toBeApproved',
      name: 'Under Review'
    },{
      value: 'accepted',
      name: 'Accepted'
    },{
      value: 'declined',
      name: 'Declined'
    }];

    this.reservation = {
      meta: {
        creationUser: this.Auth.getCurrentUserSync()._id
      }
    };

    this.customFields = {};
  }

  open(target) {
    if (target == 'start')
      this.startOpened = true;
    else
      this.endOpened = true;
  }

  $onInit() {
    this.config = this.resolve.config;

    if (this.config.event && !this.config.data) {
      this.reservation.spots = 1;
      this.reservation.event = this.config.event._id;
    }

    if (this.config.data && this.config.isAdmin) {
      this.reservation = this.config.data;

      this.customFields = this.reservation.customFields || {};

      this.isAdmin = this.config.isAdmin;

      if (!this.config.event) {
        this.reservation.start = new Date(this.reservation.start);
        this.reservation.end = new Date(this.reservation.end);
      }

      this.lblOkButton = "Update";
      this.lblHeader = "Edit Reservation";

      this.isInvalid = false;
    }

    if (this.config.customSchema) {
      this.customSchema = this.config.customSchema;
      this.customForm = ["*"];
    }

    this.takenDateRanges = this.config.takenDateRanges || [];

    this.checkValid();
  };

  checkValid() {
    if (this.config.event)
      this.checkValidEvent();
    else
      this.checkValidAmenity();
  }

  checkValidEvent() {
    if (!this.reservation.spots) {
      this.isInvalid = true;
      return;
    }

    if (this.config.event.maxReservableSpots
      && (this.reservation.spots > this.config.event.maxReservableSpots)) {
      this.isInvalid = true;
      return;
    }
    
    this.isInvalid = false;
  }

  checkValidAmenity() {
    if (!this.reservation.start || !this.reservation.end) {
      this.isInvalid = true;
      return;
    }

    let reservationStart = new Date(this.reservation.start);
    let reservationEnd = new Date(this.reservation.end);

    if (reservationStart < this.now) {
      this.isInvalid = true;
      this.reason = "The start of the reservation must not be in the past";
      return;
    }

    if (reservationStart > reservationEnd) {
      this.isInvalid = true;
      this.reason = "The start of the reservation must not be after the end date";
      return;
    }

    // Check if there are collisions with approved tasks
    for (let i=0; i<this.takenDateRanges.length; i++) {
      if ((reservationStart > this.takenDateRanges[i].start && reservationStart < this.takenDateRanges[i].end)
        || (this.takenDateRanges[i].start > reservationStart && this.takenDateRanges[i].start < reservationEnd)) {
        this.isInvalid = true;
        this.reason = "There is already an other reservation from "
          + moment(this.takenDateRanges[i].start).format('MMMM Do YYYY, h:mm') + " till "
          + moment(this.takenDateRanges[i].end).format('MMMM Do YYYY, h:mm') + " which would collide with yours";
        return;
      }
    }

    this.isInvalid = false;
    this.reason = "";
  }


  checkEndDate(data) {

  };

  submit(form) {
    if (this.customSchema) {
      this.$scope.$broadcast('schemaFormValidate');

      if (!form.$valid)
        return;
    }

    this.reservation.customFields = this.customFields || {};
    this.close({$value: this.reservation});
  }

  cancel() {
    this.dismiss({$value: 'cancel'});
  }

}

export default angular.module('conduu.reservationAddComponent', [])
  .component('reservationAdd', {
    template: require('./reservation-add.component.html'),
    bindings: {
      resolve: '<',
      config: '<',
      close: '&',
      dismiss: '&'
    },
    controller: reservationAddComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/reservation-add/reservation-add.component.js